import {
  FaBook,
  FaGamepad,
  FaUtensils,
  FaPlane,
  FaCamera,
  FaMusic,
  FaPencilAlt,
  FaRunning,
  FaBicycle,
  FaHiking,
  FaSwimmer,
  FaPalette,
  FaSeedling,
  FaOm,
  FaSpa,
  FaTheaterMasks,
  FaChess,
  FaHandsHelping,
  FaDumbbell,
  FaDog,
  FaFilm,
  FaTv,
  FaLaptopCode,
  FaMicrophone,
  FaGuitar,
  FaBasketballBall,
  FaWineGlass,
  FaGlobeEurope,
  FaPaintBrush,
  FaCoffee,
  FaBreadSlice,
  FaCampground,
  FaMountain,
  FaFistRaised,
  FaHourglassHalf,
  FaStar,
  FaTshirt,
  FaPenFancy,
  FaLeaf,
  FaAtom,
  FaBullhorn,
  FaBrain,
  FaExclamationTriangle,
  FaMobileAlt,
  FaFireAlt,
  FaMoneyBillWave,
  FaMeh,
  FaUserSecret,
  FaPizzaSlice,
  FaGhost,
  FaTasks,
  FaSkull,
  FaDonate,
} from "react-icons/fa";

const hobbiesData: {
  id: string;
  icon: string;
  name: string;
  library: string;
}[] = [
  { id: "0", icon: "🌈", name: "LQBTQ+ Friendly", library: "EMOJIE" },
  { id: "1", icon: "book", name: "Reading", library: "FontAwesome5" },
  { id: "2", icon: "gamepad", name: "Gaming", library: "FontAwesome5" },
  { id: "3", icon: "utensils", name: "Cooking", library: "FontAwesome5" },
  { id: "4", icon: "plane", name: "Travel", library: "FontAwesome5" },
  { id: "5", icon: "camera", name: "Photography", library: "FontAwesome5" },
  { id: "6", icon: "music", name: "Music", library: "FontAwesome5" },
  { id: "7", icon: "pencil-alt", name: "Writing", library: "FontAwesome5" },
  { id: "8", icon: "running", name: "Running", library: "FontAwesome5" },
  { id: "9", icon: "bicycle", name: "Cycling", library: "FontAwesome5" },
  { id: "10", icon: "hiking", name: "Hiking", library: "FontAwesome5" },
  { id: "11", icon: "swimmer", name: "Swimming", library: "FontAwesome5" },
  { id: "12", icon: "palette", name: "Art", library: "FontAwesome5" },
  { id: "13", icon: "seedling", name: "Gardening", library: "FontAwesome5" },
  { id: "14", icon: "om", name: "Yoga", library: "FontAwesome5" },
  { id: "15", icon: "spa", name: "Wellness", library: "FontAwesome5" },
  { id: "16", icon: "theater-masks", name: "Theater", library: "FontAwesome5" },
  { id: "17", icon: "chess", name: "Chess", library: "FontAwesome5" },
  {
    id: "18",
    icon: "hands-helping",
    name: "Volunteering",
    library: "FontAwesome5",
  },
  { id: "19", icon: "dumbbell", name: "Fitness", library: "FontAwesome5" },
  { id: "20", icon: "dog", name: "Dogs", library: "FontAwesome5" },
  { id: "21", icon: "film", name: "Movies", library: "FontAwesome5" },
  { id: "22", icon: "tv", name: "TV", library: "FontAwesome5" },
  { id: "23", icon: "laptop-code", name: "Coding", library: "FontAwesome5" },
  { id: "24", icon: "microphone", name: "Singing", library: "FontAwesome5" },
  { id: "25", icon: "guitar", name: "Guitar", library: "FontAwesome5" },
  {
    id: "26",
    icon: "basketball-ball",
    name: "Basketball",
    library: "FontAwesome5",
  },
  { id: "27", icon: "wine-glass", name: "Wine", library: "FontAwesome5" },
  { id: "28", icon: "globe-europe", name: "Travel", library: "FontAwesome5" },
  { id: "29", icon: "paint-brush", name: "Painting", library: "FontAwesome5" },
  { id: "30", icon: "coffee", name: "Coffee", library: "FontAwesome5" },
  { id: "31", icon: "bread-slice", name: "Baking", library: "FontAwesome5" },
  { id: "32", icon: "campground", name: "Camping", library: "FontAwesome5" },
  { id: "33", icon: "mountain", name: "Mountains", library: "FontAwesome5" },
  { id: "34", icon: "fist-raised", name: "Activism", library: "FontAwesome5" },
  {
    id: "35",
    icon: "hourglass-half",
    name: "Meditation",
    library: "FontAwesome5",
  },
  { id: "36", icon: "star", name: "Astronomy", library: "FontAwesome5" },
  { id: "37", icon: "tshirt", name: "Fashion", library: "FontAwesome5" },
  { id: "38", icon: "pen-fancy", name: "Journaling", library: "FontAwesome5" },
  { id: "39", icon: "leaf", name: "Veganism", library: "FontAwesome5" },
  { id: "40", icon: "atom", name: "Science", library: "FontAwesome5" },
  { id: "41", icon: "bullhorn", name: "Podcasts", library: "FontAwesome5" },
  { id: "42", icon: "brain", name: "Psychology", library: "FontAwesome5" },
  {
    id: "43",
    icon: "exclamation-triangle",
    name: "Awkward Silences",
    library: "FontAwesome5",
  },
  { id: "44", icon: "mobile-alt", name: "Tech", library: "FontAwesome5" },
  { id: "45", icon: "fire-alt", name: "Hot Sauce", library: "FontAwesome5" },
  {
    id: "46",
    icon: "money-bill-wave",
    name: "Supporting Flateroo",
    library: "FontAwesome5",
  },
  { id: "47", icon: "meh", name: "Neutral", library: "FontAwesome5" },
  { id: "48", icon: "user-secret", name: "Mystery", library: "FontAwesome5" },
  {
    id: "49",
    icon: "pizza-slice",
    name: "Midnight Snacking",
    library: "FontAwesome5",
  },
  { id: "50", icon: "ghost", name: "Ghost Stories", library: "FontAwesome5" },
  { id: "51", icon: "tasks", name: "Planning", library: "FontAwesome5" },
  { id: "52", icon: "skull", name: "Skulls", library: "FontAwesome5" },
  { id: "53", icon: "donate", name: "Gifts", library: "FontAwesome5" },
];

export const getHobbyInfo = (hobbyId: string) => {
  const hobby = hobbiesData.find((h) => h.id === hobbyId);
  return hobby || { icon: "❓", name: "Unknown", library: "EMOJIE" };
};

// Icon name to component mapping
const iconMap: Record<
  string,
  React.ComponentType<{ size?: number; style?: React.CSSProperties }>
> = {
  book: FaBook,
  gamepad: FaGamepad,
  utensils: FaUtensils,
  plane: FaPlane,
  camera: FaCamera,
  music: FaMusic,
  "pencil-alt": FaPencilAlt,
  running: FaRunning,
  bicycle: FaBicycle,
  hiking: FaHiking,
  swimmer: FaSwimmer,
  palette: FaPalette,
  seedling: FaSeedling,
  om: FaOm,
  spa: FaSpa,
  "theater-masks": FaTheaterMasks,
  chess: FaChess,
  "hands-helping": FaHandsHelping,
  dumbbell: FaDumbbell,
  dog: FaDog,
  film: FaFilm,
  tv: FaTv,
  "laptop-code": FaLaptopCode,
  microphone: FaMicrophone,
  guitar: FaGuitar,
  "basketball-ball": FaBasketballBall,
  "wine-glass": FaWineGlass,
  "globe-europe": FaGlobeEurope,
  "paint-brush": FaPaintBrush,
  coffee: FaCoffee,
  "bread-slice": FaBreadSlice,
  campground: FaCampground,
  mountain: FaMountain,
  "fist-raised": FaFistRaised,
  "hourglass-half": FaHourglassHalf,
  star: FaStar,
  tshirt: FaTshirt,
  "pen-fancy": FaPenFancy,
  leaf: FaLeaf,
  atom: FaAtom,
  bullhorn: FaBullhorn,
  brain: FaBrain,
  "exclamation-triangle": FaExclamationTriangle,
  "mobile-alt": FaMobileAlt,
  "fire-alt": FaFireAlt,
  "money-bill-wave": FaMoneyBillWave,
  meh: FaMeh,
  "user-secret": FaUserSecret,
  "pizza-slice": FaPizzaSlice,
  ghost: FaGhost,
  tasks: FaTasks,
  skull: FaSkull,
  donate: FaDonate,
};

// Get FontAwesome5 icon component from react-icons
export const getFa5Icon = (iconName: string) => {
  return iconMap[iconName] || null;
};
